import React from 'react'
import { Alert } from '@material-ui/lab'
import { Grid } from '@material-ui/core'

const AlertBox = ({ severity, message, elevation, variant, dataTest }) => {
  return (
    <Grid item>
      <Alert
        severity={severity}
        elevation={elevation}
        variant={variant}
        data-test={dataTest}
      >
        {message}
      </Alert>
    </Grid>
  )
}

export default AlertBox
